export default function VPNService() {
  return (
    <section id="vpn-service" className="py-32 bg-white">
      <div className="max-w-5xl mx-auto px-8 text-center">
        <h2 className="text-5xl font-bold text-[#1A2B4A] mb-8" style={{ fontFamily: 'Georgia, serif' }}>
          Enterprise-Grade Encryption
        </h2>
        <div className="space-y-8 text-lg leading-relaxed text-[#4A4A4A]">
          <p>
            SERGAS VPN utilizes military-grade AES-256 encryption to ensure your online activities remain completely private and secure. Our advanced technology creates an impenetrable tunnel between your device and the internet, protecting your sensitive data from hackers, ISPs, and government surveillance.
          </p>
          <p>
            With servers strategically located across the globe, SERGAS VPN provides lightning-fast connection speeds without compromising security. Whether you're streaming content, conducting business transactions, or simply browsing the web, our VPN service ensures your digital footprint remains invisible and your personal information stays protected at all times.
          </p>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-[#F8F9FA] to-white p-8 rounded-2xl border border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-[#00A8E8] to-[#0088C8] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">No Logs Policy</h3>
            <p className="text-[#4A4A4A] leading-relaxed">
              We never track, collect, or store your online activities. Your privacy is our top priority.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white p-8 rounded-2xl border border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-[#00A8E8] to-[#0088C8] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-global-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Global Network</h3>
            <p className="text-[#4A4A4A] leading-relaxed">
              Access content from anywhere with our worldwide server network spanning multiple continents.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#F8F9FA] to-white p-8 rounded-2xl border border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-[#00A8E8] to-[#0088C8] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-flashlight-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Lightning Fast</h3>
            <p className="text-[#4A4A4A] leading-relaxed">
              Enjoy blazing-fast speeds with unlimited bandwidth for seamless streaming and browsing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
